/**
 * i18n — Re-export translation helpers from the engine for UI components.
 *
 * Usage in UI modules:
 *   import { t, getCurrentLang, setCurrentLang } from '@ui/lib/i18n';
 */

import { t, getCurrentLang, setCurrentLang, TRANSLATIONS } from '@engine/index';

export { t, getCurrentLang, setCurrentLang, TRANSLATIONS };

/**
 * getMonthShort — returns array of 12 translated short month names.
 * Uses t() so it respects the current language setting.
 */
export function getMonthShort() {
    return Array.from({ length: 12 }, (_, i) => t('month_short_' + (i + 1)));
}

/**
 * formatPeriodShort — formats "pr Jan 2026" style period label using translated months.
 * @param {number} monthTo - 1-based month number
 * @param {number} year
 */
export function formatPeriodShort(monthTo, year) {
    const months = getMonthShort();
    return `pr ${months[(monthTo || 1) - 1]} ${year}`;
}
